import { AxiosInstance } from 'axios';

import * as types from '../../../../../../../typings/api/integrations/leica/rest/v1/skymap-leica-connection';

export class SkyMapLeicaConnectionServiceV1 implements types.Handlers {
  private readonly endpoint = '/v1/skymap-leica-connection';

  constructor(private axios: AxiosInstance) {}

  async getSkyMapLeicaConnection(
    params: types.GetSkyMapLeicaConnectionParameters,
  ): Promise<types.GetSkyMapLeicaConnectionResponse> {
    return (await this.axios.get(`${this.endpoint}`, { params: params.query })).data;
  }

  async removeSkyMapLeicaConnection(
    params: types.RemoveSkyMapLeicaConnectionParameters,
  ): Promise<void> {
    return (
      await this.axios.delete(`${this.endpoint}/${params.path.skyMapLeicaConnectionId}`, {
        params: params.query,
      })
    ).data;
  }

  async getAsbuiltPoints(
    params: types.GetAsbuiltPointsParameters,
  ): Promise<types.GetAsbuiltPointsResponse> {
    return (
      await this.axios.get(`${this.endpoint}/${params.path.skyMapLeicaConnectionId}/asbuilt`, {
        params: params.query,
      })
    ).data;
  }
}
